import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import EmptyDiscussions from "@Components/CustomTopicContent/EmptyDiscussions"
import { EvaluationCardItem } from "@Components/FollowUp/Evaluation/EvaluationCardItem"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { QuizzContext } from "@Providers/QuizzProvider"
import { userAtom } from "@Recoil/Atom/userAtom"
import { quizAldreadyReplied } from "@Screens/Knowledge/Savoirs/Evaluation/EvaluationLogic"
import { KnowledgeService } from "@Services/Knowledge/Knowledge.Service"
import React, { useContext, useEffect, useState } from "react"
import { ActivityIndicator, FlatList, RefreshControl, View } from "react-native"
import { useRecoilValue } from "recoil"
import styles from "./styles"
import { useIsFocused } from "@react-navigation/native"
import CustomEmptyData from "@Components/CustomEmptyData"

export const EvaluationHome = ({ navigation }) => {
    const [fetching, setFetching] = useState(false)
    const [evaluations, setEvaluations] = useState([])
    const user = useRecoilValue(userAtom)
    const { setSelectedQuizz } = useContext(QuizzContext)
    const isFocused = useIsFocused()
    const gotoQuizz = (item) => {
        setSelectedQuizz(item)
        navigation.navigate("EvaluationQuizz", { isResult: true })
    }

    const knowledgeType = (typeId) => {
        switch (typeId) {
            case 2:
                return "savoir-faire"

            case 3:
                return "savoir-etre"

            default:
                return "savoirs"
        }
    }

    const fetchEvaluations = () => {
        setFetching(true)
        KnowledgeService.getEvaluations()
            .then((results) => {
                const res = results?.data?.data
                if (res?.length > 0) {
                    const optimizedData = Array.from(res, (item) => {
                        const hasReplied = quizAldreadyReplied({ quizItem: item, userId: user?.id })
                        if (hasReplied) {
                            return {
                                id: item.id,
                                badge: knowledgeType(item.quizzType),
                                title: item.title,
                                questions: item.questions,
                                hasReplied
                            }
                        }
                    })
                    const removeUndefined = optimizedData?.filter((item) => item !== undefined)
                    setEvaluations(removeUndefined || [])
                }

                setFetching(false)
            })
            .catch(() => {
                setFetching(false)
            })
    }

    useEffect(() => {
        fetchEvaluations()
    }, [isFocused])

    const renderItem = ({ item }) =>
        item?.id && (
            <EvaluationCardItem
                key={item?.id}
                onPress={() => gotoQuizz(item)}
                badge={item?.badge}
                title={item?.title}
            />
        )

    return (
        <ContainerStackScreen>
            <BreeSerifText color={baseColors.green.primary} fontSize={24}>
                Je m'évalue
            </BreeSerifText>
            <Spacer height={15} />
            <OpenSansText fontSize={16}>Retrouvez tous les résultats des quiz auxquels vous avez répondu.</OpenSansText>
            <Spacer height={10} />

            <View style={{ flex: 1 }}>
                {fetching ? (
                    <View style={styles.loading}>
                        <ActivityIndicator color={baseColors.green.primary} size={50} />
                    </View>
                ) : (
                    <FlatList
                        data={evaluations || []}
                        showsVerticalScrollIndicator={false}
                        ListEmptyComponent={<CustomEmptyData label="Aucune évaluation." />}
                        renderItem={renderItem}
                        keyExtractor={(item) => item?.id?.toString()}
                        contentContainerStyle={styles.contentContainer}
                        refreshControl={<RefreshControl refreshing={fetching} onRefresh={fetchEvaluations} />}
                    />
                )}
            </View>
        </ContainerStackScreen>
    )
}
